module.exports = __webpack_public_path__ + "img/34.dce257a0.png";